<template>
  <div>
    <v-carousel
      hide-delimiter-background
      cycle
      :height="$vuetify.breakpoint.xsOnly ? 200 : $vuetify.breakpoint.smOnly ? 320 : 600"
      show-arrows
      interval="4000"
      delimiter-icon="mdi-minus"
    >
      <v-carousel-item v-for="(banner, index) in banners" :key="index">
        <v-img :src="banner.src" :alt="banner.alt" class="banner-image" cover />
      </v-carousel-item>
    </v-carousel>

    <div class="banner-text">
      <h2 class="banner-title">( ELSONIII ) เอลสันIII เชื่อมคุณเชื่อมโลกสังคมสันต์สุข บริการครบ จบ อิ่มใจ ยินดี</h2>
      <p class="banner-subtitle">
        ลงโฆษณา สินค้า และบริการ ตลาดขายออนไลน์, รับสร้างบ้าน, ออกแบบโครงการ <br />
        งานสือสาร, ประชาสัมพันธ์, ประชุมสัมมนา
      </p>
      <p class="banner-tagline">ร่วมเส้นทางธุรกิจ เติบโตร่วมกันกับเอลสัน</p>
    </div>

    <v-container class="about-section">
      <v-row align="center" justify="space-between">
        <v-col cols="12" md="6" class="pr-md-8">
          <h1 class="about-h1">มาทำความรู้จักกับ</h1>
          <br>
          <h3 class="about-h3">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;กิจการร่วมค้า กรกรฏ ก๊อด แอนด์ คอนซัลแต้นท์ ยูนิเวิร์ส คอร์ปอเรชั่น ,ห้างหุ้นส่วนจำกัดเชียงรายมหานคร
            ห้างหุ้นส่วนจำกัด กรกรฏ ก๊อด แอนด์ คอนซัลแต้นท์, บริษัท เอลสันIII จำกัด, บริษัทในเครือกรุ๊ปฯ
          </h3>
          <br />
          <p class="about-text">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เราเป็นนิติบุคคลซึ่งออกแบบงานสำหรับก่อสร้าง บริหารจัดการ
            ควบคุมงาน อำนวยการก่อสร้าง ตรวจสอบคุณภาพงาน ให้เกิดความมั่นคงยั่งยืนของโครงสร้าง
            เราดูแลทุกขั้นตอนตามความต้องการ และงบประมาณของท่าน
            <br /><br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;นอกจากนี้ เรายังมุ่งมั่นพัฒนาองค์กรร่วมกับท่าน ในทางด้าน
            บุคลากร ระบบการทำงาน และมาตรฐานงานก่อสร้างที่ตรวจสอบได้
            ไม่เพียงแค่ความมั่นคงแข็งแรงเท่านั้น แต่ยังส่งผ่านถึงความตั้งใจ
            ความซื่อสัตย์ และใส่ใจในบริการเป็นส่วนหนึ่งในความสำเร็จของทุกท่าน
          </p>
        </v-col>

        <v-col cols="12" md="6" class="text-center">
          <v-carousel
            cycle
            interval="3500"
            hide-delimiter-background
            delimiter-icon="mdi-minus"
            show-arrows-on-hover
            class="about-carousel"
            height="320"
          >
            <v-carousel-item v-for="(img, i) in aboutSlides" :key="i">
              <v-img :src="img.src" :alt="img.alt" contain height="320" />
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "AboutUSBannerDetail",
  data() {
    return {
      banners: [
        { src: "/promote/Elson1.jpg", alt: "Banner 1" },
        { src: "/promote/Elson2.jpg", alt: "Banner 2" },
        { src: "/promote/Elson3.jpg", alt: "Banner 3" },
        { src: "/promote/Elson4.jpg", alt: "Banner 4" },
      ],
      aboutSlides: [
        { src: "/promote/Elson1.jpg", alt: "Elson 1" },
        { src: "/promote/Elson2.jpg", alt: "Elson 2" },
        { src: "/promote/Elson3.jpg", alt: "Elson 3" },
        { src: "/promote/Elson4.jpg", alt: "Elson 4" },
      ],
    };
  },
};
</script>

<style scoped>
.banner-image {
  width: 100%;
  height: 100%;
}

.banner-text {
  text-align: center;
  padding: 60px 24px 40px;
  background-color: #ffffff;
}

.banner-title {
  font-weight: 700;
  font-size: 32px;
  color: #F4811F;
  margin-bottom: 10px;
  line-height: 1.5;
}

.banner-subtitle {
  font-size: 20px;
  font-weight: 500;
  color: #555555;
  margin-bottom: 12px;
}

.banner-desc {
  font-size: 17px;
  color: #444444;
  line-height: 1.9;
  margin-bottom: 8px;
}

.banner-tagline {
  font-size: 18px;
  font-weight: 600;
  color: #F4811F;
  margin-top: 8px;
}

.about-section {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
  padding-top: 100px;
}

@media (min-width: 1440px) and (max-width: 1919px) {
  .about-section {
    max-width: 1200px;
  }
}

.about-h1 {
  font-size: 38px;
  font-weight: 700;
  color: #111827;
}

.about-h3 {
  font-size: 18px;
  font-weight: 500;
  color: #374151;
  line-height: 1.8;
}

.about-text {
  font-size: 17px;
  line-height: 2.0;
  color: #374151;
  letter-spacing: 0.01em;
}
.about-carousel {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.about-slide-img {
  width: 100%;
  border-radius: 16px;
}

@media (max-width: 768px) {
  .banner-text {
    padding: 28px 16px 24px;
  }

  .banner-title {
    font-size: 20px;
    line-height: 1.6;
  }

  .banner-subtitle {
    font-size: 15px;
  }

  .banner-desc {
    font-size: 14px;
    line-height: 1.8;
  }

  .banner-tagline {
    font-size: 15px;
  }

  .about-section {
    padding: 40px 16px 60px !important;
  }

  .about-h1 {
    font-size: 24px;
  }

  .about-h3 {
    font-size: 15px;
    line-height: 1.8;
  }

  .about-text {
    font-size: 15px;
    line-height: 2.0;
  }
  .about-carousel {
    height: 220px !important;
  }
}
</style>
